import config from 'utils/apiconfig';
import request from 'utils/request';

const {api} = config;
const {ratingChief} = api;

/**
 * 查询列表
 */
export async function list(params) {
  return request({url: ratingChief, method: 'get', data: params,});
}

